import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: ${theme.spacing.lg};
    & * {
      margin: ${theme.spacing.xs} 4px;
    }
  `}
`;
